import React from 'react';
import { usePagination } from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  ul: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  flexRightItem: {
    flex: 1,
  },
  pageButton: {
    border: 0,
    background: 'none',
    outline: 0,
    fontSize: theme.typography.body1.fontSize,
    '&:disabled': {
      color: theme.palette.grey[500],
    },
  },
  selectedPage: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  changerButton: {
    textTransform: 'capitalize',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    fontSize: theme.typography.body2.fontSize,
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: 'inherit',
    position: 'relative',
    top: '0.1em',
  },
}));

export default function UsePagination(props) {
  const classes = useStyles();
  const {
    count,
    onChange,
    page,
    backIconButtonText = 'Previous',
    nextIconButtonText = 'Next',
  } = props;
  const { items } = usePagination({
    count: count,
    onChange: onChange,
    page: page,
  });

  const [prev, ...pages] = items;
  const [next] = pages.splice(pages.length - 1, 1);
  const result = [...pages, prev, next];

  return (
    <nav>
      <ul className={classes.ul}>
        {result.map(({ page, type, selected, ...item }, index) => {
          let children;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = '…';
          } else if (type === 'page') {
            children = (
              <button
                type="button"
                className={
                  clsx({ [classes.selectedPage]: selected }) +
                  ' ' +
                  classes.pageButton
                }
                {...item}
              >
                {page}
              </button>
            );
          } else {
            children = (
              <button
                type="button"
                className={classes.pageButton + ' ' + classes.changerButton}
                {...item}
              >
                {type === 'previous' && [
                  <ArrowBackIos className={classes.icon} />,
                  <span>{backIconButtonText}</span>,
                ]}
                {type === 'next' && [
                  <span>{nextIconButtonText}</span>,
                  <ArrowForwardIos className={classes.icon} />,
                ]}
              </button>
            );
          }

          return (
            <li
              className={clsx({
                [classes.flexRightItem]: type === 'page' && count === page,
              })}
              key={index}
            >
              {children}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
